import { useState } from 'react';

const exceededMaxCharacters = 'String value cannot exceed 255 characters.';

type Props = {
  errorMessage?: string;
};

export const useHandleSearchInput = ({ errorMessage = '' }: Props) => {
  const [validationMessage, setValidationMessage] = useState(errorMessage);

  const validateInput = (input: string) => {
    let validation = '';

    if (input.length > 255) {
      validation = exceededMaxCharacters;
      setValidationMessage(exceededMaxCharacters);
    } else {
      if (validationMessage && !errorMessage) {
        setValidationMessage(validation);
      }
    }

    return validation;
  };

  const isInputValid = (newValue: string) => {
    const validation = validateInput(newValue);
    validation !== validationMessage && setValidationMessage(validation);
    return !validation;
  };

  // keeping validationMessage just in case
  return { validationMessage, isInputValid };
};
